import React from "react";
import BaseSelectorReadonlyToInput from "../../../component/Select/BaseSelectorReadonlyToInput";

class ApplicationUserSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: props.title || 'Usuário',
      label: 'name',
      url: 'auth/v1/users'
    };
  }
}

export default ApplicationUserSelector;



// WEBPACK FOOTER //
// ./src/user/application/component/ApplicationUserSelector.js